import { configSettings } from '@/lib/config';
import { LOCAL_STORAGE_KEYS } from '@/lib/constants';

/**
 * Opens Instagram OAuth popup window for authentication
 * Based on Vue implementation: vue/src/pages/settings/IntegrationMixin.js
 */
export function connectInstagram(onClose?: () => void): Window | null {
    // Build Instagram OAuth URL
    const instagramOAuthUrl = new URL('https://www.instagram.com/oauth/authorize');
    instagramOAuthUrl.searchParams.append('enable_fb_login', '0');
    instagramOAuthUrl.searchParams.append('force_authentication', '1');
    instagramOAuthUrl.searchParams.append('client_id', configSettings.instagramClientId || '');
    instagramOAuthUrl.searchParams.append('redirect_uri', configSettings.instagramRedirectUri || '');
    instagramOAuthUrl.searchParams.append('response_type', 'code');
    instagramOAuthUrl.searchParams.append(
        'scope',
        'instagram_business_basic,instagram_business_manage_messages,instagram_business_manage_comments'
    );
    // Solution to ensure we stay in browser: https://developers.facebook.com/community/threads/922374286525063/
    instagramOAuthUrl.hash = 'weblink';

    // Open centered popup window for auth
    const authPopupWindow = createCenteredPopupWindow(instagramOAuthUrl.toString(), 'Connect Instagram', 500, 800);

    // Track integration progress
    setupTrackingIntegrationProgress('instagram');

    // Handle window close and trigger callback
    if (authPopupWindow) {
        const timer = setInterval(() => {
            if (authPopupWindow.closed) {
                clearInterval(timer);
                onClose?.();
            }
        }, 300);
    }

    return authPopupWindow;
}

/**
 * Creates a centered popup window
 */
function createCenteredPopupWindow(url: string, title: string, height: number, width: number): Window | null {
    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;

    return window.open(
        url,
        title,
        `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${width}, height=${height}, top=${top}, left=${left}`
    );
}

/**
 * Track integration progress in localStorage
 */
function setupTrackingIntegrationProgress(integrationType: string): void {
    let integrationInProgress: Record<string, number> =
        JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.INTEGRATION_IN_PROGRESS) || '{}') || {};

    // Add or update the integration progress
    integrationInProgress = { ...integrationInProgress, [integrationType]: 1 };

    // Store the updated integration progress in localStorage
    localStorage.setItem(LOCAL_STORAGE_KEYS.INTEGRATION_IN_PROGRESS, JSON.stringify(integrationInProgress));
}
